// utils/groupProperties.js
export const groupProperties = (data, isState) => {
    if (!Array.isArray(data)) {
      console.error("Invalid data: expected an array.");
      return {};
    }
  
    return isState
      ? data.reduce((acc, property) => {
          acc[property.state] = acc[property.state] || [];
          acc[property.state].push(property);
          return acc;
        }, {})
      : data.reduce((acc, property) => {
          const locationState = `${property.location}, ${property.state}`;
          acc[locationState] = acc[locationState] || [];
          acc[locationState].push(property);
          return acc;
        }, {});
  };
  
  
  export const filterPropertiesByLocation = (data, locationFilter) => {
    // Validate if the input data is an array
    if (!Array.isArray(data)) {
      console.error("Invalid data: expected an array.");
      return { matchedProperties: [] };
    }
  
    // Validate if locationFilter is a valid non-empty string
    if (!locationFilter || typeof locationFilter !== "string") {
      console.error("Invalid locationFilter: expected a non-empty string.");
      return { matchedProperties: [] }; // Return an empty array if no valid filter is provided
    }
  
    // Convert the location filter to lowercase for case-insensitive filtering
    const filterLower = locationFilter.toLowerCase();
  
    // Filter the properties based on the location and combine them into a single array
    const matchedProperties = data.filter(
      (property) =>
        property.projectlocation &&
        typeof property.projectlocation === "string" &&
        property.projectlocation.toLowerCase().includes(filterLower)
    );
  
    // Return the data as a single object containing all matched properties
    return { matchedProperties };
  };
  
  